import { createRouter, createWebHistory } from 'vue-router'
import { useGuestStore } from '../stores/guest.store';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: () => import('../views/HomeView.vue'),
      name: "home",
    },
    {
      path: "/character",
      component: () => import("../views/CharacterView.vue"),
      name: "character",
    },
    {
      path: "/posse",
      component: () => import("../views/PosseView.vue"),
      name: "posse",
    },
    {
      path: '/itinerary',
      component: () => import('../views/ItineraryView.vue'),
      name: 'itinerary',
    },
    {
      path: '/house',
      component: () => import('../views/Accomodations.vue'),
      name: 'accomodations',
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.name === "home") {
    next();
    return;
  }

  if (to.name === "accomodations") {
    next();
    return;
  }

  const guestStore = useGuestStore();
  if (guestStore.guest.completedSurvey) {
    next();
  } else {
    next({ name: "home" });
  }
});

export default router